export const articlesTradingDiscipline = [
  {
    slug: 'forex-news-trading',
    category: 'วิธีเทรด Forex',
    categorySlug: 'forex-trading',
    title: 'เทรดช่วงข่าวเศรษฐกิจ (News Trading) ความเสี่ยงที่ต้องรู้และวิธีรับมือ',
    description:
      'ข่าวเศรษฐกิจทำให้ราคากระโดดและ Spread กว้างขึ้นทันที บทความนี้อธิบายกลไกของความเสี่ยงช่วงข่าว พร้อมแนวทางรับมือที่เหมาะกับมือใหม่',
    readingTime: '8 นาที',
    updatedDate: '2026-10-14',
    level: 'เริ่มเทรด',
    heroImage:
      'https://readdy.ai/api/search-image?query=Educational%20flat%20fintech%20illustration%20of%20an%20economic%20calendar%20sheet%20with%20highlighted%20date%20cells%20and%20a%20small%20clock%20beside%20a%20desk%20monitor%20showing%20a%20sharp%20vertical%20price%20spike%2C%20warm%20orange%20alert%20markers%20and%20a%20widening%20bid%20ask%20gap%2C%20teal%20chart%20line%2C%20clean%20light%20background%2C%20editorial%20flat%20fintech%20style%2C%20no%20readable%20text%2C%20no%20people&width=1200&height=675&seq=art-news-trading-01&orientation=landscape&nocache=true',
    tags: ['ข่าวเศรษฐกิจ', 'News Trading', 'ความเสี่ยง'],
    intro: [
      'ช่วงเวลาที่ประกาศตัวเลขเศรษฐกิจสำคัญ ราคาสามารถวิ่งได้มากกว่าทั้งวันที่เหลือรวมกัน แต่สภาพคล่องกลับบางลงและต้นทุนสูงขึ้น',
      'นี่คือช่วงที่คนส่วนใหญ่คิดว่าจะทำเงินได้เร็วที่สุด และเป็นช่วงที่พอร์ตเสียหายเร็วที่สุดเช่นกัน',
    ],
    sections: [
      {
        id: 'why-price-jumps',
        heading: 'ทำไมข่าวถึงทำให้ราคากระโดด',
        paragraphs: [
          'ก่อนข่าว ตลาดจะสะสมความคาดหวังไว้ในราคาแล้ว เมื่อตัวเลขจริงออกมาต่างจากที่คาด ฝั่งที่คาดผิดจะต้องปิดสถานะพร้อมกัน เกิดเป็นคำสั่งก้อนใหญ่ในเสี้ยววินาที',
          'ในช่วงนั้นผู้ให้สภาพคล่องจะถอยออกก่อน ราคาจึงกระโดดข้ามระดับไปได้หลาย pip และ Spread อาจกว้างขึ้นหลายเท่าตัวชั่วคราว',
        ],
        bullets: [
          'ราคาเคลื่อนเพราะฝั่งที่คาดผิดต้องรีบปิดสถานะ',
          'สภาพคล่องบางลงทำให้ Spread กว้างขึ้นชั่วคราว',
          'คำสั่งที่ค้างอยู่ห่างจากราคาอาจถูกจับคู่ผิดฝั่ง',
        ],
        steps: [],
      },
      {
        id: 'traps',
        heading: 'กับดักที่พบบ่อยในช่วงข่าว',
        paragraphs: [
          'กับดักแรกคือการเข้าไม้ก่อนข่าวเพราะเดาทิศทาง กับดักที่สองคือตั้ง Stop Loss ประชิดเกินไปจนถูกตัดด้วยความผันผวน และกับดักที่สามคือตั้งคำสั่งทั้งสองฝั่งไว้แล้วหวังให้ฝั่งหนึ่งทำกำไร',
          'ทุกวิธีเหล่านี้มีจุดบอดเดียวกัน คือความผันผวนช่วงข่าวไม่เป็นเส้นตรง มีทั้งการวิ่งผิดทางก่อนแล้วค่อยกลับ ซึ่งตัดทั้งสองฝั่งได้ในนาทีเดียว',
        ],
        bullets: [
          'เดาทิศก่อนข่าวแล้วเข้าตั้งแต่ยังไม่ประกาศ',
          'ตั้ง Stop Loss แคบเกินกว่าความผันผวนปกติ',
          'วางคำสั่งสองฝั่งแบบ OCO แล้วหวังกำไรอัตโนมัติ',
        ],
        steps: [],
      },
      {
        id: 'how-to-handle',
        heading: 'แนวทางรับมือแบบมือใหม่',
        paragraphs: [
          'ทางที่ปลอดภัยที่สุดคือไม่เปิดออเดอร์ใหม่ก่อนและหลังข่าวสิบห้าถึงสามสิบนาที ถ้ามีสถานะเปิดอยู่แล้ว ควรลดขนาดหรือปิดทำกำไรบางส่วนก่อนประกาศ',
          'ถ้าอยากฝึกเรื่องข่าวจริง ๆ ให้ใช้บัญชีทดลองและจดผลลัพธ์ไว้หลายสิบครั้งก่อน เพราะข้อมูลจากการสังเกตจะบอกได้ดีกว่าการเดา',
        ],
        bullets: [
          'งดเปิดออเดอร์ใหม่ในหน้าต่างข่าว 15 ถึง 30 นาที',
          'ตรวจปฏิทินเศรษฐกิจทุกเช้าก่อนวางแผนวัน',
          'ถ้าถือสถานะอยู่ ให้ลดขนาดหรือล็อกกำไรก่อนประกาศ',
          'จดผลของข่าวแต่ละครั้งไว้เป็นข้อมูลของตัวเอง',
        ],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'ข่าวไหนสำคัญที่สุดสำหรับ Forex',
        a: 'ข่าวที่เกี่ยวกับดอกเบี้ยและเงินเฟ้อของสหรัฐฯ เช่น การประชุมธนาคารกลางและตัวเลข CPI เพราะกระทบทุกคู่เงินที่มีดอลลาร์',
        a2: 'รองลงมาคือตัวเลขตลาดแรงงานอย่าง Non-Farm Payrolls และข่าวของ ECB หรือ BoJ เมื่อตัวเลขออกมาต่างจากคาดการณ์มาก ราคาอาจขยับ 50-100 Pip ภายในไม่กี่นาที',
      },
      {
        q: 'เทรดหลังข่าวทันทีได้ไหม',
        a: 'หลังประกาศไม่กี่นาที Spread ยังกว้างและราคาแกว่งแรง ควรรอให้ตลาดสงบลงก่อนอย่างน้อยสิบห้านาที',
        a2: 'ในช่วงนั้น Spread อาจกว้างขึ้น 5-8 เท่าและแท่งเทียนแรกอาจยาว 30-50 Pip ซึ่งทำให้ Stop Loss ที่ตั้งไว้ถูกตัดโดยไม่เกี่ยวกับทิศทางจริง',
      },
      {
        q: 'ถ้าถือออเดอร์ข้ามข่าวควรทำอย่างไร',
        a: 'ลดขนาดสถานะลงหรือปิดบางส่วน และต้องยอมรับว่าความเสี่ยงจริงอาจสูงกว่าที่คำนวณไว้เพราะสลิปเพจ',
        a2: 'วิธีที่ปลอดภัยคือลด Lot ลงครึ่งหนึ่งก่อนข่าว หรือปิดทำกำไรส่วนหนึ่ง แล้วถือที่เหลือโดยยอมรับว่าอาจถูกเลื่อนจุดปิดได้',
      },
    ],
    related: ['forex-execution-cost', 'forex-market-hours', 'forex-overtrading'],
  },
  {
    slug: 'forex-overtrading',
    category: 'วิธีเทรด Forex',
    categorySlug: 'forex-trading',
    title: 'Overtrading เทรดมากเกินไป อาการ ต้นเหตุ และวิธีแก้ที่ได้ผลจริง',
    description:
      'เทรดบ่อยเกินไปทำให้ต้นทุนสะสมและสมาธิเสื่อม บทความนี้ชี้สัญญาณเตือนของ Overtrading และวิธีลดจำนวนออเดอร์โดยไม่ต้องกลัวพลาดโอกาส',
    readingTime: '7 นาที',
    updatedDate: '2026-10-13',
    level: 'เริ่มเทรด',
    heroImage:
      'https://readdy.ai/api/search-image?query=Educational%20flat%20fintech%20illustration%20of%20an%20overcrowded%20trading%20screen%20covered%20with%20dozens%20of%20small%20order%20tickets%2C%20buy%20and%20sell%20arrows%20and%20sticky%20notes%20scattered%20everywhere%2C%20one%20teal%20candlestick%20chart%20buried%20underneath%2C%20warm%20orange%20warning%20accent%2C%20cluttered%20but%20clean%20light%20background%2C%20editorial%20flat%20fintech%20style%2C%20no%20text%2C%20no%20people&width=1200&height=675&seq=art-overtrading-01&orientation=landscape&nocache=true',
    tags: ['Overtrading', 'วินัย', 'พฤติกรรม'],
    intro: [
      'วันไหนที่คุณเปิดออเดอร์มากที่สุด มักเป็นวันที่มีผลลัพธ์แย่ที่สุด แต่ก็เป็นวันที่รู้สึกว่า "กำลังทำงานหนัก" ที่สุดเช่นกัน',
      'Overtrading ไม่ใช่การเทรดเยอะ แต่คือการเทรดโดยไม่มีเหตุผลใหม่รองรับ นั่นคือการจ่ายต้นทุนเพื่อความสบายใจชั่วคราว',
    ],
    sections: [
      {
        id: 'what-is',
        heading: 'Overtrading คืออะไรกันแน่',
        paragraphs: [
          'Overtrading คือการเปิดออเดอร์เกินกว่าที่แผนกำหนด เพราะความอยากมีสถานะเปิดอยู่ตลอดเวลา ไม่ใช่เพราะมีสัญญาณใหม่',
          'ผลกระทบที่ชัดที่สุดคือต้นทุน จาก Spread และค่าคอมมิชชันจะถูกหักทุกไม้ ยิ่งเทรดมาก กำไรที่ต้องทำให้ได้เพื่อเสมอตัวก็ยิ่งสูงขึ้น',
        ],
        bullets: [
          'ต้นทุนต่อไม้ถูกคูณด้วยจำนวนไม้ที่เพิ่มขึ้น',
          'สมาธิและคุณภาพการตัดสินใจลดลงตามจำนวนออเดอร์',
          'ความเสี่ยงรวมต่อวันสูงเกินกว่าที่วางแผนไว้',
        ],
        steps: [],
      },
      {
        id: 'signs',
        heading: 'สัญญาณเตือนว่าคุณกำลังเทรดเกิน',
        paragraphs: [
          'สัญญาณที่พบบ่อยที่สุดคือการเปิดออเดอร์ทันทีหลังปิดไม้ เพราะรู้สึกว่าต้องชดเชยหรือต่อกำไรให้ได้',
          'อีกสัญญาณหนึ่งคือการแบ่งไม้เดียวเป็นหลายไม้เล็ก ๆ เพื่อให้รู้สึกว่ามีออเดอร์อยู่ตลอด หรือการเปลี่ยนคู่เงินไปเรื่อย ๆ เพราะคู่ที่ถืออยู่ไม่ขยับ',
        ],
        bullets: [
          'เปิดไมใหม่ภายในไม่กี่นาทีหลังปิดไม้ก่อนหน้า',
          'จำนวนออเดอร์ต่อวันเกินกว่าที่แผนระบุชัดเจน',
          'เปลี่ยนคู่เงินหรือไทม์เฟรมไปมาเพราะเบื่อ',
          'รู้สึกหงุดหงิดเมื่อไม่มีสถานะเปิดอยู่',
        ],
        steps: [],
      },
      {
        id: 'fix',
        heading: 'วิธีลดจำนวนออเดอร์โดยไม่เสียโอกาส',
        paragraphs: [
          'กำหนดเพดานจำนวนออเดอร์ต่อวันไว้ล่วงหน้า เช่น สองถึงสามไม้ และถือเป็นกติกาเดียวกับ Stop Loss ห้ามต่อรอง',
          'อีกวิธีคือกำหนดว่าต้องมีเงื่อนไขครบทุกข้อในแผนจึงจะกดได้ การบังคับให้ตรวจเช็กลิสต์ทุกครั้งจะตัดไม้ impulsive ออกไปได้มากในทันที',
        ],
        bullets: [
          'กำหนดเพดานจำนวนไม้ต่อวันและต่อสัปดาห์',
          'ใช้เช็กลิสต์เงื่อนไขเข้าที่ต้องครบทุกข้อ',
          'ตั้งเวลาเทรดเป็นช่วงสั้น ๆ แล้วปิดจอเมื่อหมดเวลา',
          'วัดผลด้วย "คุณภาพของไม้" ไม่ใช่จำนวนไม้',
        ],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'เทรดวันละกี่ไม้จึงถือว่าเหมาะสม',
        a: 'ไม่มีตัวเลขสากล แต่ถ้าแผนของคุณบอกว่าเหมาะสมกับสองถึงสามไม้ แล้วคุณเปิดสิบไม้ นั่นคือสัญญาณว่าเกินแผนแล้ว',
        a2: 'เกณฑ์ที่ใช้ได้จริงคือกำหนดจำนวนไม้สูงสุดต่อวันและเพดานขาดทุนต่อวัน เช่น 3 ไม้หรือ 3% ของพอร์ต แล้วหยุดเมื่อถึงเงื่อนไขใดก่อน',
      },
      {
        q: 'ลดจำนวนไม้แล้วจะพลาดโอกาสไหม',
        a: 'โอกาสในตลาดมีทุกวัน แต่เงินทุนมีจำกัด การพลาดโอกาสไม่ทำให้พอร์ตเสียหาย การฝ่ากติกาต่างหากที่ทำให้',
        a2: 'มองว่าการไม่เทรดก็คือการตัดสินใจแบบหนึ่ง การรักษาเงินทุนไว้เพื่อไม้ที่มีคุณภาพจริงคุ้มกว่าการฝืนเปิดไม้เพราะกลัวตกรถ',
      },
      {
        q: 'แก้ Overtrading ได้ด้วยการเพิ่มเงินทุนไหม',
        a: 'ไม่ได้ เพราะต้นเหตุคือพฤติกรรมไม่ใช่ขนาดพอร์ต การเพิ่มทุนจะทำให้ผลเสียรุนแรงขึ้น',
        a2: 'เมื่อพอร์ตใหญ่ขึ้น ขนาดขาดทุนต่อไม้ก็ใหญ่ขึ้นตาม การแก้จึงต้องแก้ที่กติกาและบันทึกผล ไม่ใช่ที่จำนวนเงินในบัญชี',
      },
    ],
    related: ['forex-trading-plan', 'forex-trading-journal', 'risk-management-basics'],
  },
  {
    slug: 'forex-trading-psychology',
    category: 'วิธีเทรด Forex',
    categorySlug: 'forex-trading',
    title: 'จิตวิทยาการเทรด Forex กับดักความกลัวและความโลภที่ทำลายแผน',
    description:
      'อารมณ์คือสาเหตุที่คนส่วนใหญ่ทำตามแผนไม่ได้ บทความนี้พาดูกับดักทางอารมณ์สี่แบบที่พบบ่อย พร้อมกฎที่วัดผลได้เพื่อป้องกัน',
    readingTime: '8 นาที',
    updatedDate: '2026-10-11',
    level: 'เริ่มเทรด',
    heroImage:
      'https://readdy.ai/api/search-image?query=Educational%20flat%20fintech%20illustration%20of%20a%20balanced%20wooden%20scale%20on%20a%20desk%2C%20one%20side%20holding%20a%20teal%20candlestick%20chart%20card%20and%20the%20other%20side%20holding%20stacks%20of%20warm%20orange%20coins%2C%20subtle%20tension%20lines%20showing%20imbalance%2C%20clean%20light%20background%2C%20calm%20composition%2C%20editorial%20flat%20fintech%20style%2C%20no%20text%2C%20no%20people&width=1200&height=675&seq=art-psychology-01&orientation=landscape&nocache=true',
    tags: ['จิตวิทยา', 'อารมณ์', 'วินัย'],
    intro: [
      'ช่วงที่แผนถูกทำลายบ่อยที่สุดไม่ใช่ตอนที่ตลาดยาก แต่คือตอนที่คุณเพิ่งขาดทุนหรือเพิ่งได้กำไรก้อนใหญ่',
      'จิตวิทยาการเทรดจึงไม่ใช่เรื่องของการทำใจให้สบาย แต่คือการออกแบบระบบให้อารมณ์แทรกแซงได้ยากขึ้น',
    ],
    sections: [
      {
        id: 'why-emotion-wins',
        heading: 'ทำไมอารมณ์ถึงชนะแผนเสมอ',
        paragraphs: [
          'เพราะการกดปุ่มใช้เวลาไม่ถึงหนึ่งวินาที ขณะที่การทบทวนแผนต้องใช้ความคิดเชิงเหตุผล ในเสี้ยววินาทีนั้น สมองจะเลือกทางที่ลดความรู้สึกไม่สบายที่สุดก่อนเสมอ',
          'ยิ่งสถานะเปิดอยู่และราคาแกว่งเร็ว ความรู้สึกจะถูกกระตุ้นซ้ำทุกครั้งที่เปิดดูกราฟ ยิ่งดูบ่อย ยิ่งมีโอกาสตัดสินใจตามอารมณ์มากขึ้น',
        ],
        bullets: [
          'การตัดสินใจเร็วเกินกว่าที่เหตุผลจะทำงาน',
          'ยิ่งดูกราฟบ่อย ยิ่งถูกกระตุ้นทางอารมณ์บ่อย',
          'ความเจ็บจากขาดทุนหนักกว่าความสุขจากกำไรในขนาดเดียวกัน',
        ],
        steps: [],
      },
      {
        id: 'traps',
        heading: 'กับดักทางอารมณ์ 4 แบบที่พบบ่อย',
        paragraphs: [
          'กับดักเหล่านี้ไม่ใช่จุดอ่อนส่วนบุคคล แต่เป็นรูปแบบที่เกิดกับแทบทุกคน การรู้ชื่อมันช่วยให้จับได้เร็วขึ้น',
        ],
        bullets: [
          'Revenge trading ขาดทุนแล้วรีบเปิดไม้ใหม่ทันทีเพื่อเอาคืน',
          'ตัดกำไรเร็วเกินไปเพราะกลัวกำไรหาย',
          'เลื่อน Stop Loss ให้ห่างออกไปเพราะไม่อยากยอมรับขาดทุน',
          'เพิ่มขนาดล็อตหลังได้กำไรติดกันเพราะคิดว่าตัวเองอ่านตลาดเก่งแล้ว',
        ],
        steps: [],
      },
      {
        id: 'rules',
        heading: 'สร้างระบบป้องกันด้วยกฎที่วัดผลได้',
        paragraphs: [
          'กฎที่ดีต้องมีตัวเลข ไม่ใช่คำว่า "ต้องมีสติ" เพราะวัดไม่ได้ ถ้าขาดทุนต่อวันถึงเพดานที่กำหนด ให้ปิดแพลตฟอร์มแล้วหยุดจนถึงวันถัดไป',
          'อีกวิธีที่ได้ผลคือกำหนดจำนวนครั้งในการดูกราฟต่อวัน และใช้คำสั่งรอราคาแทนการเฝ้าจอ เพื่อลดจำนวนครั้งที่อารมณ์มีโอกาสแทรก',
        ],
        bullets: [
          'กำหนดเพดานขาดทุนต่อวันเป็นตัวเลขชัดเจน',
          'ห้ามแก้ Stop Loss ให้ห่างจากจุดเริ่มต้น',
          'ใช้คำสั่งรอราคาเพื่อลดการเฝ้าจอ',
          'หยุดพักอย่างน้อยหนึ่งวันหลังขาดทุนถึงเพดาน',
        ],
        steps: [],
      },
    ],
    faqs: [
      {
        q: 'จิตวิทยาแก้ได้ด้วยการฝึกสมาธิไหม',
        a: 'ช่วยได้บางส่วน แต่ปัจจัยที่ใหญ่กว่าคือระบบและกติกาที่ชัดเจน เพราะระบบที่ดีจะลดจำนวนครั้งที่ต้องใช้กำลังใจ',
        a2: 'ตัวอย่างที่ได้ผลกว่าคือเขียนเงื่อนไขเข้าและออกให้ชัดเป็นข้อ ๆ และตั้ง Stop Loss ทุกไม้ทันทีที่เปิด ซึ่งตัดสินใจแทนเราในจังหวะที่อารมณ์แรง',
      },
      {
        q: 'ทำไมเลื่อน Stop Loss แล้วมักจบแย่กว่าเดิม',
        a: 'เพราะการเลื่อนคือการเพิ่มความเสี่ยงโดยไม่เพิ่มเหตุผล และมักทำตอนที่ตลาดกำลังสวนทางอย่างชัดเจนอยู่แล้ว',
        a2: 'การเลื่อน Stop Loss ออกไป 20 Pip อาจฟังดูน้อย แต่ถ้า Lot ใหญ่ก็เท่ากับเพิ่มความเสี่ยงอีกหลายเท่า และมักจบด้วยการขาดทุนก้อนใหญ่แทนที่จะเป็นก้อนเล็กตามแผน',
      },
      {
        q: 'ควรหยุดเทรดนานแค่ไหนหลังขาดทุนหนัก',
        a: 'อย่างน้อยหนึ่งวันเต็ม และกลับมาเมื่อตรวจบันทึกแล้วเห็นสาเหตุชัดเจน ไม่ใช่กลับมาเพราะอยากเอาคืน',
        a2: 'ในช่วงหยุดควรทบทวนว่าขาดทุนเพราะระบบหรือเพราะทำผิดแผน ถ้าทำตามแผนครบทุกข้อแต่ยังแพ้ ก็ต้องสะสมข้อมูลให้มากพอ เช่น 30-50 ไม้ ก่อนสรุปว่าแผนมีปัญหา',
      },
    ],
    related: ['forex-overtrading', 'forex-trading-journal', 'risk-management-basics'],
  },
];